import Vue from 'vue'
import Router from 'vue-router'
import BankTransfer from '@/views/BankTransfer.vue'
import AlipayTransfer from '@/views/AlipayTransfer.vue'
import WalletTransfer from '@/views/WalletTransfer.vue'
import WechatTransfer from '@/views/WechatTransfer.vue'
import UsdtTransfer from '@/views/UsdtTransfer.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  // 路径小写，与后端 landingPathForTypeCode 生成的 payData 一致
  routes: [
    {
      path: '/banktransfer/:merchantOrderNo',
      name: 'BankTransfer',
      component: BankTransfer
    },
    {
      path: '/alipaytransfer/:merchantOrderNo',
      name: 'AlipayTransfer',
      component: AlipayTransfer
    },
    {
      path: '/wallettransfer/:merchantOrderNo',
      name: 'WalletTransfer',
      component: WalletTransfer
    },
    {
      path: '/wechattransfer/:merchantOrderNo',
      name: 'WechatTransfer',
      component: WechatTransfer
    },
    {
      path: '/usdttransfer/:merchantOrderNo',
      name: 'UsdtTransfer',
      component: UsdtTransfer
    }
  ]
})